import type { Frequency } from 'models/series';

// Index series only have meaningful numeric history at longer cadences. This module is
// intentionally dependency-light so both client charts and server cache planning share it.
const SHORT_FORECAST_FREQUENCIES = new Set<Frequency>(['daily', 'hourly', 'fifteen_min']);

// These weather series intentionally never show the numeric forecast.
const FORCE_HIDDEN_NUMERIC_FORECAST_SERIES = new Set([
    'KXHIGHNY',
    'KXHIGHMIA',
    'KXHIGHCHI',
    'KXHIGHAUS',
    'KXHIGHDEN',
    'KXHIGHPHIL',
    'KXHIGHHOU',
    'KXHIGHLAX',
]);

export type NumericForecastSuppressionReason = 'force_hidden_series' | 'short_cadence_index';

export const isIndexForecastSuppressed = (seriesTicker: string, frequency: Frequency | undefined): boolean => {
    const isIndexSeries = seriesTicker.includes('INX') || seriesTicker.includes('NASDAQ');
    return isIndexSeries && !!frequency && SHORT_FORECAST_FREQUENCIES.has(frequency);
};

export const getNumericForecastSuppressionReason = (
    seriesTicker: string,
    frequency: Frequency | undefined,
): NumericForecastSuppressionReason | undefined => {
    if (FORCE_HIDDEN_NUMERIC_FORECAST_SERIES.has(seriesTicker)) return 'force_hidden_series';
    if (isIndexForecastSuppressed(seriesTicker, frequency)) return 'short_cadence_index';
    return undefined;
};
